import app from './../index';
import Pageable from './../Pageable';

export default class RechnungenController {

	constructor ($routeParams) {
		this.params = {
			offen: $routeParams.offen
		};

		this.refresh();
	}

	refresh() {
		this.pageable = new Pageable(app.api.rechnungen);
		this.pageable.refresh(this.params);
	}
}

RechnungenController.$inject = ['$routeParams'];



/** WEBPACK FOOTER **
 ** ./public/app/rechnungen/RechnungenController.js
 **/